<template>
  <div>
    <b-modal
        :title="$t('Join meeting request')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        no-close-on-backdrop>
      <ValidationObserver ref="form" tag="form" @submit.prevent="approved()">
        <b-form-group>
          <b-input-group class="input-group-trans">
            <b-form-input v-model="notification.Title" readonly/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-alphabetically.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-input-group class="input-group-trans">
            <b-form-input v-model="notification.Fullname" readonly/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-user.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-input-group class="input-group-trans">
            <b-form-input v-model="notification.TransID" readonly/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-id.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-input-group class="input-group-trans">
            <b-form-input v-model="notification.PhoneNumber" readonly/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-mobile.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-input-group class="input-group-trans">
            <b-form-input v-model="notification.Email" readonly/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-mail.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group :class="notification.IsApproved ? 'mb-0' : ''">
          <b-input-group class="input-group-trans">
            <b-form-input v-model="notification.Schedule" readonly/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-calendar.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group class="mb-0" v-if="!notification.IsApproved">
          <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">
            {{
              $t("Approved")
            }}
          </b-button>
        </b-form-group>
      </ValidationObserver>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
  </div>
</template>

<script>
import dialogHelper from "../helpers/dialog_helper";
import joinRequestService from "../services/join_request_service";

export default {
  name: "NotificationJIRequestModal",
  data: function () {
    return {
      loading: false,
      show: false,
      idNotify: null,
      idRequest: null,
      notification: {

      }
    }
  },
  methods: {
    async approved() {
      let result = await dialogHelper.confirm("Are you sure to approved this request?")
      if (!result)
        return;

      this.loading = true;
      let response = await joinRequestService.approveJIRequests(this.idNotify, this.idRequest);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      dialogHelper.alert(response.substr(3), "success");
      this.show = false;
      this.$emit("approved", this.idNotify, this.idRequest);
    },
    async open(idNotify, idRequest) {
      this.loading = true;
      this.idNotify = idNotify;
      this.idRequest = idRequest;
      const response = await joinRequestService.getRequest(idNotify, idRequest);
      this.loading = false;

      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      this.notification = JSON.parse(response.substr(3));
      this.show = true;
      this.$emit("open", idNotify, idRequest)
    }
  }
}
</script>

<style scoped>

</style>